<template>
  <div>
    <v-snackbar
      v-model="dialog.snackbar"
      top
      right
      color="green">
      <span class="body-1 font-weight-light white--text"
        v-html="message.success">
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          class="body-1 font-weight-bold text-capitalize"
          color="white"
          icon
          v-bind="attrs"
          @click="dialog.snackbar = false">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <v-row>
      <v-col
        cols="12"
        md="7"
        class="py-0">
        <v-card
          outlined
          class="pa-4"
          height="calc(100vh - 195px)"
          style="overflow-y: auto;">
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.load"
            type="image, article, list-item-two-line, article, list-item-two-line">
            <div>
              <div v-if="!process.load && Object.keys(detail).length > 0">
                <v-card
                  flat
                  class="mb-4"
                  style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                  <v-img 
                    contain
                    height="300"
                    alt="amanata" 
                    :src="detail.image_url === '' ? require('@/assets/image/image_default.png') : detail.image_url"
                    class="ma-auto"
                    style="border-radius: 10px;">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          color="white">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>

                <v-row>
                  <v-col
                    cols="12"
                    md="12">
                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        {{ detail.title }}
                      </div>

                      <div
                        class="line-text-second">
                        Dibuat {{ detail.input_datetime | date }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Indikator
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.indicator_name }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Deskripsi
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.desc }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Lokasi
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.location }}
                      </div>
                    </div>

                    <div
                      class="mb-4">
                      <div
                        class="body-1 font-weight-bold black--text">
                        Tanggal
                      </div>

                      <div
                        class="line-text-second">
                        {{ detail.start_date | date }} <span class="mx-2">s/d</span> {{ detail.end_date | date }}
                      </div>
                    </div>

                    <div>
                      <div
                        class="body-1 font-weight-bold black--text">
                        Jam
                      </div>

                      <div
                        class="line-text-second">
                        {{ `${detail.start_time.split(':')[0]}:${detail.start_time.split(':')[1]}` }} <span class="mx-2">s/d</span> {{ `${detail.end_time.split(':')[0]}:${detail.end_time.split(':')[1]}` }}
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <!-- <div
                  class="d-flex align-center mb-1">
                  Total Pengunjung : <strong class="black--text ml-1">{{ detail.user_event.length }}</strong>
                </div>

                <v-simple-table
                  class="my-2"
                  height="700"
                  style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Foto
                        </th>
                        <th class="text-left">
                          Nomor Induk Pegawai
                        </th>
                        <th class="text-left">
                          Unit
                        </th>
                        <th class="text-left">
                          Nama Lengkap
                        </th>
                        <th class="text-left">
                          Telepon
                        </th>
                        <th class="text-left">
                          Tanggal
                        </th>
                      </tr>
                    </thead>
                    
                    <tbody
                      style="height: calc(100vh - 300px); overflow-y: auto;">
                      <tr
                        v-for="(item, index) in detail.user_event"
                        :key="index"
                        style="opacity: 70%;">
                        <td
                          style="border: none !important;">
                          <v-avatar
                            size="30">
                            <v-img 
                              contain
                              alt="amanata" 
                              :src="item.user_image_url !== '' ? item.user_image_url : require('@/assets/image/image_default.png')"
                              class="ma-auto"
                              style="border-radius: 10px;">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    color="white">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </td>
                        <td
                          style="border: none !important;">
                          {{ item.user_code }}
                        </td>
                        <td
                          style="border: none !important;">
                          {{ item.unit_name }}
                        </td>
                        <td
                          style="border: none !important;">
                          {{ item.user_name }}
                        </td>
                        <td
                          style="border: none !important;">
                          {{ item.user_mobilephone }}
                        </td>
                        <td
                          style="border: none !important;">
                          {{ item.created_datetime | datetime }}
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table> -->
              </div>
            </div>
          </v-skeleton-loader>
        </v-card>
      </v-col>

      <v-col
        cols="12"
        md="5"
        class="py-0">
        <v-card
          outlined
          class="pa-4"
          height="calc(100vh - 195px)"
          style="overflow-y: auto;">
          <v-skeleton-loader
            class="ma-auto"
            :loading="process.load"
            type="image, image, article, list-item-two-line"
            style="border-radius: 0px;">
            <div
              class="mb-8">
              <div v-if="!process.load && Object.keys(detail).length > 0"
                class="d-flex justify-center my-3">
                <qr-code 
                  id="download_qr"
                  :text="detail.uuid"
                  :size="rps !== 'lg' ? 275 : 500">
                </qr-code>
              </div>
            </div>

            <div
              class="text-center">
              <v-btn
                @click="to_download()"
                color="green"
                elevation="0"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text">
                Download QR Kode
              </v-btn>
            </div>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="!process.load && Object.keys(detail).length > 0">
      <v-col
        cols="12">
        <div
          class="d-flex align-center mt-4 mb-1">
          <div>
            Total Pengunjung : <strong class="black--text ml-1">{{ detail.user_event.length }}</strong>
          </div>

          <v-spacer />

          <v-btn
            @click="prints()"
            :disabled="process.print"
            :loading="process.print"
            color="#444444"
            elevation="0"
            style="border-radius: 10px;"
            class="body-2 font-weight-bold text-capitalize white--text">
            <v-icon>mdi-microsoft-excel</v-icon>
            
            <span
              class="ml-1">
              Export
            </span>
          </v-btn>
        </div>

        <v-simple-table
          class="my-2"
          height="700"
          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Foto
                </th>
                <th class="text-left">
                  Nomor Induk Pegawai
                </th>
                <th class="text-left">
                  Unit
                </th>
                <th class="text-left">
                  Nama Lengkap
                </th>
                <th class="text-left">
                  Telepon
                </th>
                <th class="text-left">
                  Tanggal
                </th>
              </tr>
            </thead>
            
            <tbody
              style="height: calc(100vh - 300px); overflow-y: auto;">
              <tr
                v-for="(item, index) in detail.user_event"
                :key="index"
                style="opacity: 70%;">
                <td
                  style="border: none !important;">
                  <v-avatar
                    size="30">
                    <v-img 
                      contain
                      alt="amanata" 
                      :src="item.user_image_url !== '' ? item.user_image_url : require('@/assets/image/image_default.png')"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>
                </td>
                <td
                  style="border: none !important;">
                  {{ item.user_code }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.unit_name }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.user_name }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.user_mobilephone }}
                </td>
                <td
                  style="border: none !important;">
                  {{ item.created_datetime | datetime }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false
        },

        detail: {},
        process: {
          load: false,

          print: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.48)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.05)`
      }
    },
    watch: {
      
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        
        let params = {
          id: this.$route.params.id
        }

        await get(`admin/event/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      to_download () {
        let img = document.querySelector("#download_qr img").src

        const a = document.createElement('a')
        a.download = `QR-Code-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.png`
        a.href = img
        a.click()
      },

       async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          id: this.detail.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/event/export_participant`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          if (res.status === 200) {
            this.process.print = false
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `Presensi-Peserta-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)
            document.body.appendChild(link)
            link.click()
          } else {
            this.process.print = false
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>